import React, { useContext } from "react"
import { HomePageContext } from "@tmu/context/homePageContext"

const useFooterType = (options) => {
  const { footerType, setFooterType } = useContext(HomePageContext)
  setFooterType(options?.footerType)
}

export default useFooterType
